import selIcon from "../../assets/icons/selected_Icon.svg";
import {
  AdminprofileImage,
  Navbar,
  AnimateSpin,
  Pagination,
  CategoryCard,
  Btn,
  Text,
} from "../../components/index";
import { fontSizes } from "../../constants/constants";
import subCategoriesFunction from "./index.function";
const SelectCategoryScreen = () => {
  const {
    navigate,
    isLoading,
    subCategories,
    selectedSubCategoryIds,
    setSelectedSubCategoryIds,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
    dispatch,
    TextWeight,
  } = subCategoriesFunction();
  return (
    <div className="flex">
      <Navbar />
      <div className="flex-1 flex flex-col h-screen">
        <div className="px-4 lg:px-12 pt-10">
          <AdminprofileImage onBack={() => navigate(`/service/category`)} />
          <Text
            text={"Select Sub Category"}
            size={fontSizes.h30}
            weight={TextWeight.Raleway_Bold}
            color="text-black"
            isTruncate={false}
            className={"py-8"}
          />
        </div>
        <div className="flex-1 overflow-y-auto h-full hide-scrollbar px-4 lg:px-12 py-2">
          {isLoading ? (
            <AnimateSpin />
          ) : (
            <>
              {subCategories?.data?.length > 0 ? (
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-10">
                  {subCategories?.data?.map((subCategory) => (
                    <CategoryCard
                      key={subCategory?._id}
                      cateCardtitle={subCategory?.name}
                      cateCardImg={`${subCategory?.image}`}
                      selectedcateCardImg={`${subCategory?.image}`}
                      selectedIcon={selIcon}
                      isPublished={subCategory?.isPublished}
                      // selected={selectedSubCategoryIds.includes(subCategory?._id)}
                      selected={selectedSubCategoryIds === subCategory?._id}
                      // onSelect={() => handleSelect(subCategory?._id)}
                      onSelect={() =>
                        setSelectedSubCategoryIds(subCategory?._id)
                      }
                    />
                  ))}
                </div>
              ) : (
                <Text
                  text={"No subcategories available for this category"}
                  size={fontSizes.h18}
                  weight={TextWeight.Raleway_Bold}
                  color="text-black"
                  isCenter={true}
                  isTruncate={false}
                />
              )}
            </>
          )}
        </div>
        <div className="px-4 lg:px-12 pb-4 lg:pb-10 pt-2">
          <div className="w-full flex justify-center">
            {totalItems > 12 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          <Btn
            onClick={() => {
              navigate(`/service/category/subcategory/uploadfile`);
              dispatch({
                type: "UPDATE_SUBCATEGORY_IDS",
                payload: { subCategoryIds: selectedSubCategoryIds },
              });
            }}
            type={"submit"}
            isDisabled={!selectedSubCategoryIds}
            isprimary={false}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"Next"}
            color="text-white"
            hover={"hover:text-primary hover:bg-white hover:border-primary"}
            bgColor={"bg-primary border-transparent"}
            className={"mx-auto mb-4 sm:mb-7 lg:mb-10 mt-2"}
          />
        </div>
      </div>
    </div>
  );
};
export default SelectCategoryScreen;
